export default __webpack_public_path__ + "static/media/marauders-map-v0-02-02.731154cb.jpg";